import Vue from 'vue'
import axios from 'axios'
// import router from '@/router'
// import { Loading } from 'element-ui'
axios.defaults.timeout = 22000
axios.defaults.withCredentials = true
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
// let loading

const instance = axios.create({ method: 'post' })
// 请求响应拦截器
instance.interceptors.request.use(request => {
  // request.headers.Authorization = window.sessionStorage.getItem('token')
  // 展示加载器
  // loading = Loading.service({
  //   lock: true,
  //   // text: '提交中……',
  //   spinner: 'el-icon-loading',
  //   background: 'rgba(0, 0, 0, 0.5)',
  //   customClass:'custom-class-loading'
  // })
  return request
})
// 响应拦截器1
instance.interceptors.response.use(
  response => {
    let { code, message } = response.data
    if (code != 200) {
      if (message) {
        Vue.prototype.$message({
          message: `${message}`,
          type: 'warning'
        })
      }
    }

    // 关闭加载
    // loading.close()
    return response
  },
  error => {
    // loading?.close()
    Vue.prototype.$message({
      message: `请求错误，请稍候再尝试！`,
      type: 'error',
      duration: 500
    })
    // }
    return Promise.reject(error)
  }
)


export function request(confing) {
  if (process.env.NODE_ENV === 'production') {
    instance.defaults.baseURL = process.env.VUE_APP_URL
  }
  // instance.defaults.baseURL = '/kia'
  return instance(confing)
}
